<template>
  <div class="warpper">
    <nav-bar @goBack="goBack" :isFixed="false" ></nav-bar>
    <div class="auth-box">
      <div class="auth-title">身份认证</div>
      <div class="auth-desc">选择其中一种身份后将不可更改</div>
    </div>
    <div class="content">
      <div class="content-box" @click="select(1)">
        <div class="left-img">
          <img src="../../../assets/member/indetity/company.png" alt />
        </div>
        <div class="right">
          <div class="title">公司</div>
          <div class="desc">认证后仅可开通债务人</div>
        </div>
      </div>
      <div class="content-box" @click="select(2)">
        <div class="left-img">
          <img src="../../../assets/member/indetity/personal.png" alt />
        </div>
        <div class="right">
          <div class="title">个人</div>
          <div class="desc">认证后可开通债务人、债权人和经纪人</div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="dialogShow"
      title="提示"
      confirmButtonColor="#F9591B"
      show-cancel-button
      :closeOnClickOverlay="false"
      @confirm="confirm"
      @cancel="cancel"
    >
      <p class="tip" v-if="type==1">您确认选择公司身份后则不可更改</p>
      <p class="tip" v-if="type==2">您确认选择个人身份后则不可更改</p>
    </van-dialog>
  </div>
</template>

<script>
import navBar from "../../debtRelief/components/navBar";
export default {
  data() {
    return {
      dialogShow: false,
      type: 0 //1公司  2个人

    };
  },
  components: {
    navBar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {},
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    select(type) {
      this.dialogShow = true;
      this.type = type;
    },
    personal() {
      this.params("", "", "personal");
    },
    confirm() {
      if(this.type == 1) {
        this.$router.push({
          path: '/companyInfo',
          query: {
            token: this.$route.query.token
          }
        })
      }else {
        this.personal();
      }
    },
    cancel() {
      this.dialogShow = false;
      this.type = 0;
    }
  },
};
</script>

<style lang="less">
.warpper {
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    border: none;
    box-shadow: none;
    background: #ffffff;
    width: 100%;
    .van-icon {
      color: #333;
    }
  }
  .van-hairline--bottom:after{
    border-bottom-width: 0px !important;
  }
  .auth-box {
    padding-left: 21px;
    .auth-title {
      height: 29px;
      line-height: 29px;
      font-size: 24px;
      font-weight: 500;
      color: #333333;
      margin-top: 24px;
    }
    .auth-desc {
      height: 23px;
      line-height: 23px;
      font-size: 14px;
      color: #999999;
    }
  }
  .content {
    padding: 24px 12px 0;
    .content-box {
      margin-bottom: 15px;
      padding: 27px 21px;
      display: flex;
      align-items: center;
      box-shadow:0px 6px 16px 0px rgba(153,153,153,0.12);
      border-radius:4px;
      border:1px solid rgba(238,238,238,1);
      .left-img {
        display: flex;
        align-items: center;
        img {
          width: 45px;
          height: 45px;
        }
      }
      .right {
        margin-left: 15px;
        .title {
          height:32px;
          font-size:20px;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:32px;
        }
        .desc {
          font-size:14px;
          color:rgba(153,153,153,1);
          line-height:23px;
        }
      }
    }
  }
  .tip {
    padding: 0 10px;
    text-align: center;
    padding-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
}
</style>
 